module.exports = __webpack_public_path__ + "static/media/Rectangle28.3f5188da.png";